import { Box, IconButton, Grid, Tooltip } from '@mui/material';
import MaterialTable from 'material-table';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import Popup from "../../../../Base/views/Popup"
import { useState } from 'react';
// import ConfirmationDialog from '../../../../Base/views/ConfirmationDialog';
import { 
    // DeleteTransportAllowanceAction, 
    GetTransportAllowanceAction } from '../../../../../../store/Finance/PayRollTemplate/Action';
import TransportAllowance from './TransportAllowance';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TransportAllowanceGrid = () => {
    const dispatch = useDispatch();
    const { transport_allowance_data, isLoadingTransportAllowance } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    // const [openDialog, setOpenDialog] = useState(false);
    // const [currentData, setCurrentData] = useState({});
  useEffect(() => {
        dispatch(GetTransportAllowanceAction());          
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };

    // const handleAdd = () => {
    //     setEditedRecord()
    //     setOpenPopup(true);
    // };

    // const handleConfirmDelete = (rowData) => {
    //     setOpenDialog(true);
    //     setCurrentData(rowData)
    // };

    // const handleDelete = () => {
    //     setOpenDialog(false);
    //     dispatch(DeleteTransportAllowanceAction({ transport_allowance_configuration_pk: currentData?.transport_allowance_configuration_pk }))
    // };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };

    // const addButton = transport_allowance_data?.length < 1 && (<Button onClick={handleAdd} variant="contained" className="mpl-primary-btn" startIcon={<AddIcon />} >
    //     Add
    // </Button>);
    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            <Grid item xs={12} md={12}>
                <Box>
                    <MaterialTable
                        isLoading={isLoadingTransportAllowance}
                        columns={[
                             { 
                                title: "Allowance Type", 
                                field: "transport_allowance_type", 
                                cellStyle: { padding: "10px 10px 10px 13px" } 
                            },
                            { 
                                 title: (
                                    <span>
                                        Flat Amount / Month&nbsp;
                                        <Tooltip title="A fixed monthly amount that is pro-rated based on employee attendance." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "flat_amount", 
                                cellStyle: { padding: "10px 10px 10px 15px" },
                                hidden: transport_allowance_data?.[0]?.transport_allowance_type === "Variable"
                            },
                            { 
                                title: (
                                    <span>
                                        Variable Allowance Daily Rate&nbsp;
                                        <Tooltip title="A daily travel rate paid for each payable day. In monthly summaries, calculated as daily rate × number of payable days." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "variable_transport_allowance_rate", 
                                cellStyle: { padding: "10px 10px 10px 15px" },
                                hidden: transport_allowance_data?.[0]?.transport_allowance_type === "Flat"
                            }
                        ]}
                        data={transport_allowance_data}
                        options={{
                            maxBodyHeight: 220,
                            rowStyle: { fontSize: "13px" },
                            headerStyle: { padding: "5px 30px 5px 10px", fontWeight: "bold", height:"60px" },
                            sorting: false,
                            search: false,
                            searchFieldAlignment: "right",
                            searchAutoFocus: true,
                            searchFieldVariant: "standard",
                            filtering: false,
                            paging: false,
                            selection: false,
                            actionsColumnIndex: -1,
                            grouping: false,
                            addRowPosition: "first",
                        }}
                        onSelectionChange={(rows) => { return (rows.filter(row => row?.status === "Submitted")) }}
                        actions={[
                            {
                                icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                tooltip: "Edit",
                                onClick: (_event, rowData) => { handleEdit(rowData) },
                            },
                            // {
                            //     icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                            //     tooltip: "Delete",
                            //     onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                            // },
                        ]}
                        title= ""
                        components={{
                            Toolbar: props => (
                                <div style={{
                                    minHeight: "10px",
                                    padding: "10px 25px",
                                    borderRadius:"5px 5px 0px 0px"

                                }}>
                                    {props.title}
                                </div>
                            )
                        }}
                    />
                    <Popup
                        fullWidth={true}
                        maxWidth="sm"
                        title={editedRecord ? "Edit" : "Add"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}

                    >
                        <TransportAllowance editedRecord={editedRecord} addMode={addMode} setOpenPopup={setOpenPopup} />
                    </Popup>
                    {/* <ConfirmationDialog
                        title="Do you wish to proceed?"
                        openDialog={openDialog}
                        closeDialog={setOpenDialog}
                        popupTitle="Country Management"
                        OkButtonText="Delete"
                        onSubmit={handleDelete}
                    /> */}
                </Box>
            </Grid>
        </Grid>
    );
}

export default TransportAllowanceGrid;
